import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginServiceService } from './login-service.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAutenticadoService implements CanActivate {

  constructor(private loginServiceService: LoginServiceService,
    private router: Router) { }
  canActivate(){
    if (this.loginServiceService.logado() ===true) {
      console.log('logado');
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }
}
